import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgEdit({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6.586L17.414 11l-9.121 9.122a3 3 0 01-1.923.872L6.172 21H4a1 1 0 01-1-1V17.83a3 3 0 01.743-1.977l.136-.145L13 6.586zm0 2.828l-7.707 7.708a1 1 0 00-.284.575l-.01.132V18A1 1 0 006 19h.172a1 1 0 00.608-.206l.099-.087L14.586 11 13 9.414zM14.586 5l1.207-1.207a3.121 3.121 0 014.55 4.27l-.136.144L19 9.414 14.586 5l1.207-1.207L14.586 5zm4.207.207a1.122 1.122 0 00-1.232-.239l-.12.06 1.532 1.53a1.122 1.122 0 00-.18-1.35z"
        fill={color}
      />
    </svg>
  )
}

export default SvgEdit
